import { useCrud } from '@next-qr/lib-ui/hooks';
import type { CrudListOptions, CrudGetOptions } from '@next-qr/lib-ui/hooks/useCrud';
import { userApi } from './api';

export interface User {
  id: number;
  email: string;
  name: string;
  bio: string | null;
  timezone: string;
  locale: string;
}

const crud = useCrud<User>(userApi);

export const useUserList   = (options?: CrudListOptions) => crud.useList({ ...options, subscriptionFn: userApi.subscribe });
export const useUser       = (id: string | number, options?: CrudGetOptions) => crud.useGet(id, { ...options, subscriptionFn: userApi.subscribe });
export const useCreateUser = (options?: Parameters<typeof crud.useCreate>[0]) => crud.useCreate(options);
export const useUpdateUser = (options?: Parameters<typeof crud.useUpdate>[0]) => crud.useUpdate(options);
export const useRemoveUser = (options?: Parameters<typeof crud.useRemove>[0]) => crud.useRemove(options);
